import React from 'react'
import { Card } from 'primereact/card'
import GrowlMessenger from '../growl/GrowlMessenger'
import { ContentLoadingOverlay } from '../loadingSpinner/ContentLoadingOverlay'
import './Page.scss'

function getHeader(props) {
  if (props.header) {
    return (
      <div className="page__header">
        <GrowlMessenger />
        <Card className="page-header-card">{props.header}</Card>
      </div>
    )
  }
  return (
    <div className="page__content">
      <GrowlMessenger />
    </div>
  )
}

function resolveContent(content) {
  if (content) {
    return <Card style={{ marginBottom: '10px' }}>{content}</Card>
  }
  return null
}

/**
 * `loading` vela **so o conteudo** enquanto a consulta nao volta (paginar, ordenar, filtrar, voltar
 * do formulario). O header fica de fora de proposito: a toolbar da listagem (Novo, Pesquisar) e o
 * menu continuam clicaveis, o usuario nao fica preso esperando a grade.
 */
export const Page = (props) => (
  <div className="page">
    {getHeader(props)}
    <div className={props.loading ? 'page__content page__content--loading' : 'page__content'}>
      {props.loading && <ContentLoadingOverlay />}

      {/* Padrao da aplicacao */}
      {resolveContent(props.content)}

      {/* Liberacao de consulta de convenio */}
      {/* <div style={{'marginBottom': '10px'}}>
        {props.content}
      </div> */}
    </div>
  </div>
)
